import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IInterviewRequestInviteSentPayload {
  postingId: string;
  totalInvitesSent: number;
  totalCandidatesSelected: number;
  totalInterviews: number;
}

/**
 * Fires when the user sends invites in the interview request flow
 * Event: dental_portal:interview_request:invite_sent
 */
export function fireInterviewRequestInviteSent(
  payload: IInterviewRequestInviteSentPayload,
): void {
  PosthogService.getInstance().track('dental_portal:interview_request:invite_sent', {
    posting_id: payload.postingId,
    total_invites_sent: payload.totalInvitesSent,
    total_candidates_selected: payload.totalCandidatesSelected,
    total_interviews: payload.totalInterviews,
  });
}
